export default function AndarbaharRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                        align-items: center;
                    }
                    h3 {
                        font-size: 28px;
                        text-align: center
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                        text-align: center;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    #market-rules-text{
                        text-align: center;
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    #market-rules-text ul {
                        list-style-type: disc;
                        padding-left: 40px;
                    }

                    #market-rules-text li {
                        list-style: disc;
                    }
                `}
            </style>


            <div class="modal fade show" id="modalMarketRules" tabindex="-1" role="dialog" aria-labelledby="modalMarketRules" style={{ display: "block", paddingLeft: "0px", marginBottom: "20px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>

                                    <h1><b>Andar Bahar</b></h1>
                                    <h2>Rules and Regulations</h2>
                                    <hr></hr>
                                    <div>
                                        <h3><b>GAME OBJECTIVES</b></h3>
                                        <p class="pt20">Players need to predict whether a card with same value as of Joker card of that round will be drawn on Andar or Bahar side. </p>

                                    </div>

                                    <div>
                                        <h3><b>GAME RULES</b></h3>
                                        <p class="pt20"> To begin a game round the Dealer deals the first card which is commonly known as the "Joker Card". </p>
                                        <p class="pt20">After that the dealer deals a single card to each side: A card will be first drawn for Bahar and then for Andar and then for Bahar again and so forth until a card with the same value as of Joker card (regardless of the suit) will be drawn on one of the sides</p>
                                        <p class="pt20"> Once this matching card is drawn on either side the round ends. </p>
                                        <h4>The game is played with one deck of cards that are shuffled either by the dealer or shuffling machine before each round. The deck is cut after the shuffle and the dealer reveals the Joker card.</h4>
                                        <div>
                                            <h3>Betting Instructions</h3>
                                            <ul style={{ textAlign: "left" }}>
                                                <li>If a game round is in progress when you enter the game, please wait for the next one, and then, place your bets.</li>
                                                <li>After the timer reaches 0, the game round begins.</li>
                                                <li>To place a bet, click on the box, enter the stake amount and submit by clicking on Place Bet button.</li>
                                                <li>You can place several bets on different runners in different markets simultaneously.</li>
                                                <li>The timer shows how much time you have left to place your bets.</li>
                                                <li>Winnings are paid for the winning bets at the end of each game round.</li>
                                                <li>To skip a turn, simply do not place any bets.</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div style={{ textAlign: "left" }}>
                                        <center><h3>Main Bets</h3></center>
                                        <ol>
                                            <li class="lit20">1. Andar </li>
                                            <li class="lit20">2. Bahar</li>
                                        </ol>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <center><h3>Cards combinations</h3></center>
                                        <div style={{ textAlign: "left" }}>
                                            <p class="pt20"> Bet stands on the individual player, Independent of other player's hands. If the same player holds any of the below hand would yield the following payout, else customer loses the bet. </p>
                                            <table class="table table-bordered table-sm" style={{ textAlign: "left" }}>
                                                <thead>
                                                    <tr>
                                                        <th>BET</th>
                                                        <th>BACK</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th>ANDAR</th>
                                                        <th>1: 0.98</th>
                                                    </tr>
                                                    <tr>
                                                        <th>BAHAR</th>
                                                        <th>1: 0.98 (If First card Bahar winner =&gt; 1: 0.25)</th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <p class="pt20">Please note that any malfunction voids the game round and all eventual payouts for the round. Bets will be returned.</p>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}